import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import TotalAttendanceActions from '../../Data/Redux/TotalAttendanceRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import Tool from '../../Components/ReportsComponents/Tool'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class TotalAttendanceByHour extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getStudyPrograms } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance')
        getStudyPrograms(match.params.centerId)
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance')
        getStudyPrograms(activeCenter)
      }
    } else {
      this.props.getTotalAttendance()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newData = []
    const { attendance, centers, study_programs, centersInfo } = nextProps
    if (attendance || centersInfo) {
      if (this.props.user === 'Director') {
        Object.keys(attendance).map((att) => {
          const item = { date: att, formatDay: moment(att).format('MMM YYYY') }
          let total = 0
          Object.keys(attendance[att]).map((key) => {
            if (study_programs.length > 0) {
              const selectedProgram = study_programs.find(program => program.id === attendance[att][key].center_study_program_id)
              if (selectedProgram) {
                item[selectedProgram.name] = parseFloat(attendance[att][key].total_attendance_time)
                total += parseFloat(attendance[att][key].total_attendance_time)
              }
            }
          })
          item['total'] = total
          newData.push(item)
        })
      } else {
        if (centersInfo && centersInfo.total_attendance_hours_by_center) {
          Object.keys(centersInfo.total_attendance_hours_by_center).map((att) => {
            const item = { date: att, formatDay: moment(att).format('MMM YYYY') }
            let total = 0
            Object.keys(centersInfo.total_attendance_hours_by_center[att]).map((key) => {
              if (study_programs.length > 0) {
                const selectedProgram = study_programs.find(program => program.id === centersInfo.total_attendance_hours_by_center[att][key].center_study_program_id)
                if (selectedProgram) {
                  item[selectedProgram.name] = parseFloat(centersInfo.total_attendance_hours_by_center[att][key].total_attendance_time)
                  total += parseFloat(centersInfo.total_attendance_hours_by_center[att][key].total_attendance_time)
                }
              }
            })
            item['total'] = total
            newData.push(item)
          })
        }
        if (!R.isEmpty(attendance)) {
          Object.keys(attendance).map((att) => {
            const item = { date: att, formatDay: moment(att).format('MMM YYYY') }
            let total = 0
            Object.keys(attendance[att]).map((key) => {
              if (centers.length > 0) {
                const selectedCenter = centers.find(center => center.id === attendance[att][key].center_id)
                if (selectedCenter) {
                  item[selectedCenter.abbreviation] = parseFloat(attendance[att][key].total_attendance_time)
                  total += parseFloat(attendance[att][key].total_attendance_time)
                }
              }
            })
            item['total'] = total
            newData.push(item)
          })
        }
      }
      this.setState({ data: newData })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getBars = () => {
    let bars = null
    if (this.props.user === 'Director' || this.props.fromCenter) {
      bars = this.props.study_programs.map((value, index) => {
        return (
          <Bar key={index} dataKey={value.name} stackId="a" fill={this.pickColor(value.name) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
    } else {
      bars = this.props.centers.map((value, index) => {
        return (
          <Bar key={index} dataKey={value.abbreviation} stackId="a" fill={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
    }
    return bars
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/total-hours', this.props.activeCenter)
    } else {
      this.props.getTotalAttendanceExcel()
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  filter = ({ currentTarget: { id: abbreviation } }) => {
    const newState = { ...this.state }
    const { attendance, centers, study_programs, user } = this.props
    if (user === 'Director') {
      const { id } = study_programs.find(program => program.name === abbreviation)
      for (let i = 0; i < newState.data.length; i++) {
        if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 &&  newState.data[i][abbreviation] !== null)) {
          newState.data[i][abbreviation] = null
          const { date } = newState.data[i]
          const atten = attendance[date]
          const centerAttendance = atten.find(att => att.center_study_program_id === id)
          newState.data[i]['total'] -= parseFloat(centerAttendance.total_attendance_time)
        } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
          const { date } = newState.data[i]
          const atten = attendance[date]
          const centerAttendance = atten.find(att => att.center_study_program_id === id)
          newState.data[i][abbreviation] = parseFloat(centerAttendance.total_attendance_time)
          newState.data[i]['total'] += parseFloat(centerAttendance.total_attendance_time)
        }
      }
    } else {
      const { id } = centers.find(center => center.abbreviation === abbreviation)
      for (let i = 0; i < newState.data.length; i++) {
        if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 &&  newState.data[i][abbreviation] !== null)) {
          newState.data[i][abbreviation] = null
          const { date } = newState.data[i]
          const atten = attendance[date]
          const centerAttendance = atten.find(att => att.center_id === id)
          newState.data[i]['total'] -= parseFloat(centerAttendance.total_attendance_time)
        } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
          const { date } = newState.data[i]
          const atten = attendance[date]
          const centerAttendance = atten.find(att => att.center_id === id)
          newState.data[i][abbreviation] = parseFloat(centerAttendance.total_attendance_time)
          newState.data[i]['total'] += parseFloat(centerAttendance.total_attendance_time)
        }
      }
    }
    this.setState(newState)
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && (this.state.data[i][name] !== '0' && this.state.data[i][name] !== null)) {
        count++
      }
    }
    return count > 0
  }


  render() {
    const { attendance, centers, user, centersInfo } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title={user === 'Director' ? 'Horas de Asistencia Total por programa de estudio' : 'Horas de Asistencia Total por Centro'}
        date={((attendance || centersInfo) && data[0]) &&
          { initial: data[0].date, end: data[data.length - 1].date }}
        onClick={this.download}
        loading={!data[0]}
      >
        {data[0] &&
          <BarChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis />
            <Tooltip content={<Tool withoutCurrency suffix="Horas" large />} />
            <Legend content={<CustomizedLegend onClick={!this.props.fromCenter && this.filter} />} />
            {this.getBars()}
          </BarChart>
        }
      </ReportTemplate>
    )
}
}


const mapStateToProps = ({ totalAttendance, centerOptions, auth, study_programs, centersInfo }) => ({
  attendance: totalAttendance.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  study_programs: study_programs.get.results,
  centersInfo: centersInfo.attendance.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getTotalAttendance: () => dispatch(TotalAttendanceActions.getRequest({}, true)),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId)),
  getTotalAttendanceExcel: () => dispatch(TotalAttendanceActions.TotalAttendanceExcelRequest()),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TotalAttendanceByHour))



// WEBPACK FOOTER //
// ./src/Containers/Reports/TotalAttendanceByHour.jsx